import { STAGES, type Stage } from "./journeyData";

/** Horizontal scroll tabs on phones/tablets; a vertical list on the left from 1024px. */
export function JourneyStageNavigation({ active, onStage }: { active: string; onStage: (s: Stage) => void }) {
  return (
    <nav aria-label="Shift stages" data-testid="journey-stage-nav" className="print-hide">
      <ol className="-mx-5 flex gap-2 overflow-x-auto px-5 pb-2 [scrollbar-width:none] lg:mx-0 lg:flex-col lg:overflow-visible lg:px-0 lg:pb-0">
        {STAGES.map((s) => {
          const on = s.id === active;
          return (
            <li key={s.id} className="shrink-0">
              <button type="button" onClick={() => onStage(s)} aria-current={on ? "step" : undefined} data-testid={`journey-stage-tab-${s.id}`}
                className={`j-press flex min-h-[44px] w-full items-center gap-2 border-[3px] px-3 text-left font-condensed font-extrabold uppercase tracking-[0.08em] transition-colors lg:px-4 ${on
                  ? "border-[#F5D536] bg-[#F5D536] text-[#171A1F]" : "border-[#3A3F48] text-[#FFFFFF] hover:border-[#FFFFFF]"}`}>
                <span className={`text-lg ${on ? "" : "text-[#F5D536]"}`}>{s.id}</span>
                <span className="text-sm lg:hidden">{s.short}</span>
                <span className="hidden text-sm lg:inline">{s.name}</span>
              </button>
            </li>
          );
        })}
      </ol>
    </nav>
  );
}
